// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"939b05d0","123":"740002b4","153":"40c99204","453":"9bcdd46a","695":"2bc7f979","729":"c4025d5c"}[chunkId] + ".chunk.js";
};